export default __webpack_public_path__ + "static/media/11911435-5e4d-4914-b624-ffae26c7ed13.cf82acad.png";